import { applyStyles } from '../../utils/styleUtils';
import { currencySign } from '../../utils/currencySign';

const SpecialOfferElement = ({ element }) => {
    const style = applyStyles(element);

    // Parse price to extract dollar and cents
    const priceMatch = (element.price || '$19.99').match(/\$(\d+)\.(\d+)/);
    const dollars = priceMatch ? priceMatch[1] : '19';
    const cents = priceMatch ? priceMatch[2] : '99';

    return (
        <div className="element-special-offer" style={style}>
            <div className="special-offer-card">
                {element.badgeText && (
                    <div className="special-offer-badge-container">
                        <div className="special-offer-badge">{element.badgeText}</div>
                    </div>
                )}
                <button className="special-offer-button" type="button">
                    <div className="special-offer-body">
                        <div className="special-offer-details">
                            <div className="special-offer-title">
                                {element.label || 'Subscribers-only price'}
                            </div>
                            <div className="special-offer-prices">
                                <span className="special-offer-old-price">
                                    {'Original value: ' + currencySign(element) + '69.99'}
                                </span>
                            </div>
                        </div>
                        <div className="special-offer-price-block">
                            <svg
                                className="special-offer-price-shape"
                                xmlns="http://www.w3.org/2000/svg"
                                width="104"
                                height="46"
                                viewBox="0 0 104 46"
                                fill="none"
                                preserveAspectRatio="none"
                            >
                                <path
                                    fill="currentColor"
                                    d="M13.5715 3.25036C15.0796 1.20634 17.4688 0 20.009 0H96C100.418 0 104 3.58172 104 8V38C104 42.4183 100.418 46 96 46H20.009C17.4689 46 15.0796 44.7937 13.5715 42.7496L2.50435 27.7496C0.420961 24.9259 0.420962 21.0741 2.50435 18.2504L13.5715 3.25036Z"
                                />
                            </svg>
                            <div className="special-offer-price-content">
                                <div className="special-offer-price-wrap">
                                    <div className="special-offer-currency">{currencySign(element)}</div>
                                    <div className="special-offer-int-digits">{dollars}</div>
                                    <div className="special-offer-fraction-container">
                                        <div className="special-offer-fraction-digits">{cents}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </button>
            </div>
        </div>
    );
};

export default SpecialOfferElement;

